import React from "react";
import { makeStyles, Box, Typography, Grid } from "@material-ui/core";
import Button from "components/shared/button";
import Robot from "/app/assets/images/portal/robo-confirmation@2x.png";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  image: {
    width: 136,
    marginBottom: theme.spacing(2),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  text: {
    marginBottom: theme.spacing(5),
  },
}));

const ContractSubmitSuccess = ({ clearForm, providerName }) => {
  const classes = useStyles();

  return (
    <Box mt={15} mx="auto" maxWidth={440}>
      <Grid container direction="column" alignItems="center">
        <Grid item xs={12}>
          <img src={Robot} className={classes.image} />
        </Grid>

        <Grid item xs={12}>
          <Typography
            variant="h2"
            color="textPrimary"
            className={classes.header}
          >
            Agreement Sent
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography
            variant="body1"
            color="textPrimary"
            className={classes.text}
            align="center"
          >
            {`${providerName} has been created in Admin and a Slack notification has
        been sent to the channel #auto-onboarding-account-setup.`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Button
            color="secondary"
            variant="contained"
            type="submit"
            onClick={clearForm}
          >
            Send Another Agreement
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

ContractSubmitSuccess.propTypes = {
  clearForm: PropTypes.func.isRequired,
  providerName: PropTypes.string.isRequired,
};

export default ContractSubmitSuccess;
